export default "__VITE_ASSET__B5Yx7$vJ__"